import {CLEAR_JOB_DETAILS, LOAD_JOB_DETAILS_SUCCESS, LOAD_JOB_HISTORY_SUCCESS} from '../../actions/types';

const INITIAL_STATE = {
    selectedJob: {},
	content: [],
    number: null,
    totalElements: null,
    totalPages: null
};

export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_JOB_HISTORY_SUCCESS:
            return {...state,
                content: action.payload.content,
                totalPages: action.payload.totalPages,
                totalElements: action.payload.totalElements,
                number: action.payload.number
            };
        case LOAD_JOB_DETAILS_SUCCESS:
            return {...state, selectedJob: action.payload};
        case CLEAR_JOB_DETAILS:
            return INITIAL_STATE;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/jobhistory/JobHistoryReducer.js